import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Scale, Clock } from 'lucide-react';
const advantages = [{
  icon: <Scale size={28} strokeWidth={1.5} data-id="element-30" data-mp="33agg0g7z0tjw" />,
  title: 'Вузька спеціалізація',
  description: 'Працюю виключно у сфері військового права. Досконало знаю актуальне законодавство, нормативні акти та практичні нюанси процедур ТЦК та ВЛК.'
}, {
  icon: <ShieldCheck size={28} strokeWidth={1.5} data-id="element-31" data-mp="2om2d65ak153c" />,
  title: 'Повний юридичний супровід',
  description: 'Не просто надаю консультації, а особисто супроводжую в ТЦК, представляю інтереси у судах усіх інстанцій та захищаю у кримінальних провадженнях.'
}, {
  icon: <Clock size={28} strokeWidth={1.5} data-id="element-32" data-mp="2ydyedp7xtbbs" />,
  title: 'Оперативне реагування',
  description: 'У питаннях мобілізації чи вручення повісток рахунок йде на години. Миттєво включаюся в процес, готую процесуальні документи та виїжджаю на виклики.'
}];
export function Advantages() {
  return <section className="py-24 bg-background" data-id="element-33" data-mp="20uwznws36ow7">
      <div className="max-w-7xl mx-auto px-6" data-id="element-34" data-mp="3gm7avxfjlqxk">
        <div className="text-center max-w-2xl mx-auto mb-16" data-id="element-35" data-mp="3gl5wbizbimb3">
          <h2 className="text-3xl md:text-4xl font-semibold" data-id="element-36" data-mp="3ll23fr3batuv">
            Чому варто довірити свою справу мені
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-37" data-mp="3qffslbrds4r3">
          {advantages.map((adv, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="group bg-surface p-8 rounded-3xl border border-border hover:border-primary/50 transition-colors duration-300" data-id="element-38" data-mp="2xoe9izkkhp2a" data-mpi={index}>
              <div className="w-14 h-14 bg-background rounded-2xl flex items-center justify-center text-primary mb-6 border border-border group-hover:scale-110 transition-transform duration-500" data-id="element-39" data-mp="qwwur3c75koz">
                {adv.icon}
              </div>
              <h3 className="text-xl font-medium mb-3" data-id="element-40" data-mp="2j1u67qco33ov">{adv.title}</h3>
              <p className="text-secondary leading-relaxed text-sm" data-id="element-41" data-mp="2wyqx1rsscl5r">
                {adv.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}